import ButtonPrimary from "../../components/shared/ButtonPrimary";
import "./Hero.scss";
import { ReactTyped } from "react-typed";

import EsphereLeftImg from "../../assets/images/hero/esphere-left.png";
import EsphereRightImg from "../../assets/images/hero/esphere-right.png";
import EsphereCenterImg from "../../assets/images/hero/esphere-center.png";
import EsphereInnerLeftImg from "../../assets/images/hero/esphere-inner-left.png";
import EsphereInnerRightImg from "../../assets/images/hero/esphere-inner-right.png";
import LevitatingAgentImg from "../../assets/images/hero/levitating-agent.png";

export default function Hero() {
	return (
		<>
			<div className="hero">
				<div className="hero-content-wrapper content-wrapper-lg">
					{/* decorations */}
					<img
						src={EsphereLeftImg}
						alt="esphere-left"
						className="esphere-left decoration shake-slow-2"
					/>
					<img
						src={EsphereRightImg}
						alt="esphere-right"
						className="esphere-right decoration shake-slow-3"
					/>
					<img
						src={EsphereCenterImg}
						alt="esphere-center"
						className="esphere-center decoration"
					/>
					<img
						src={EsphereInnerLeftImg}
						alt="esphere-inner-left"
						className="esphere-inner-left decoration shake-slow-5"
					/>
					<img
						src={EsphereInnerRightImg}
						alt="esphere-inner-right"
						className="esphere-inner-right decoration shake-slow-6"
					/>
					<img
						src={LevitatingAgentImg}
						alt="levitating-agent"
						className="levitating-agent decoration shake-slow-7"
					/>

					<div className="hero-content">
						<h1 className="hero-title" data-aos="zoom-out">
							Discover <span className="small-txt">the</span>{" "}
							Future{" "}
							<br className="desktop-br" />
							<span className="small-txt">of</span>{" "}
							<br className="mobile-br" />
							Web
							<span className="number">
								<svg
									width="33"
									height="45"
									viewBox="0 0 33 45"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0 4H29L5.85859 22.1967H29V41H0"
										stroke="white"
										strokeWidth="7"
										strokeLinejoin="bevel"
									/>
								</svg>
							</span>{" "}
							With Vernus AI
						</h1>

						<div className="hero-typewriter">
							<ReactTyped
								strings={["Smart", "Secure", "Autonomous"]}
								typeSpeed={80}
								backSpeed={90}
								backDelay={2000}
								loop
								cursorChar="|"
								className="hero-typewriter-txt"
							/>
						</div>

						<div className="hero-btns">
							<ButtonPrimary className="hero-btn">
								Get Started
							</ButtonPrimary>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
